const tosAndPapId = {
	tos: {
		title: "Syarat dan Ketentuan",
		description:
			"Harap baca dan setujui syarat dan ketentuan untuk melanjutkan.",
		checkbox: "Saya telah membaca Syarat dan Ketentuan",
	},
	pap: {
		title: "Kebijakan Privasi",
		description: "Harap baca dan setujui kebijakan privasi untuk melanjutkan.",
		checkbox: "Setujui Kebijakan Privasi",
	},
	button: "Saya telah menyetujui Syarat dan Ketentuan serta Kebijakan Privasi",
	messages: {
		success: "Syarat dan kebijakan berhasil disetujui",
		error: "Gagal menyetujui syarat dan kebijakan",
	},
};

export default tosAndPapId;
